import { Component, inject } from '@angular/core';
import { AsyncPipe, CommonModule, NgIf } from '@angular/common';
import { RouterLinkWithHref } from '@angular/router';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { ButtonModule } from 'primeng/button';
import { AnotherLinksComponent } from './components/another-links/another-links.component';
import { SupportServiceComponent } from './components/support-service/support-service.component';
import {RegionalityService} from '../../../../../../common/services/regionality.service';
import {DialogService} from 'primeng/dynamicdialog';
import {FeedbackComponent} from '../../../../../../common/components/feedback/feedback.component';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'nav[raNavbar]',
  standalone: true,
  imports: [
    CommonModule,
    RouterLinkWithHref,
    OverlayPanelModule,
    AsyncPipe,
    ButtonModule,
    NgIf,
    AnotherLinksComponent,
    SupportServiceComponent,
  ],
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  providers: [DialogService],
})
export class NavbarComponent {
  _regionality = inject(RegionalityService);
  _dialog = inject(DialogService);


  openFeedbackModal(id: number) {
    this._dialog.open(FeedbackComponent, {
      header: 'Форма обратной связи',
      data: id
    });
  }

  openCityModal() {
    // this._modals.openModal({
    //   type: 'city',
    // });
    window.location.assign('https://rentag.ru')
  }
}
